const environment: 'audrey' | 'shark' = 'shark';

const emailSupport = 'support@sharkbridge.info'; //'support@betterbridge.com'; //:

export { environment, emailSupport };
